import { useContext, useEffect, useCallback, useState } from 'react';
import { Context, DefaultValuesContextType } from './MetaApiCloudContext';
import {
  metaStatsOpenTrades,
} from './meta-api-cloud-actions';

import {
  MetaStatMetric,
  MetaStatTrade,
  MetaStatTradeDealType,
} from './meta-api-cloud-types';
import { MetaStats } from 'metaapi.cloud-sdk';
import { META_API_TOKEN } from '../../shared/contants';

const MetaCloudStats = new MetaStats(META_API_TOKEN);

export const useMetaCloudHook = (): DefaultValuesContextType => {
  const { connection, accountId } = useContext(Context);
  return {
    connection,
    accountId,
  };
};

export const useMetaStatTrades = (): {
  trades: MetaStatTrade[];
  metrics: MetaStatMetric | null;
  loading: boolean;
} => {


  const [trades, setTrades] = useState<MetaStatTrade[]>([]);
  const [metrics, setMetrics] = useState<MetaStatMetric | null>(null);


  const [loading, setLoading] = useState(true);
  const { connection } = useMetaCloudHook();
  const accountInformation = connection?.account;
  const fetchTrades = useCallback(async () => {
    const openTrades = await metaStatsOpenTrades(accountInformation?.id as string, accountInformation?.region as string);
    const metricData = await MetaCloudStats.getMetrics(accountInformation?.id as string);

    setTrades(
      openTrades
        .filter(
          (trade) =>
            trade.type === MetaStatTradeDealType.DealTypeBuy ||
            trade.type === MetaStatTradeDealType.DealTypeSell,
        )
        .sort(function(a, b) {
          return (
            new Date(b?.closeTime as string).getTime() -
            new Date(a?.closeTime as string).getTime()
          );
        }),
    );
    setMetrics(metricData);
    setLoading(false);
  }, [accountInformation?.id, accountInformation?.region]);


  useEffect(() => {
    if (accountInformation?.id) {
      fetchTrades();
      setInterval(() => {
        fetchTrades();
      }, 60000);
    }
  }, [accountInformation?.id, fetchTrades]);

  return { trades, loading, metrics };
};
